import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { QRcodeService } from "../api";

export const actionGetCreateQR = createAsyncThunk(
  "order/create-Qr",
  async (data, { rejectWithValue }) => {
    try {
      const res = await QRcodeService.doGetCreateQR(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

export const actionVerifyQR = createAsyncThunk(
  "order/verify-Qr",
  async (data, { rejectWithValue }) => {
    try {
      const res = await QRcodeService.doVerifyQR(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

const QRcodeSlice = createSlice({
  name: "QRcode",
  initialState: {
    createQR: {
      loading: false,
      data: null,
      error: "",
    },
    verifyQR: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // actionGetCreateQR
      .addCase(actionGetCreateQR.pending, (state) => {
        state.createQR.loading = true;
      })
      .addCase(actionGetCreateQR.fulfilled, (state, action) => {
        state.createQR.loading = false;
        state.createQR.data = action.payload;
      })
      .addCase(actionGetCreateQR.rejected, (state, action) => {
        state.createQR.loading = false;
        state.createQR.data = action.payload;
        state.createQR.error = action.error.message || "Something went wrong";
      })
      // actionGetCreateQR
      .addCase(actionVerifyQR.pending, (state) => {
        state.verifyQR.loading = true;
      })
      .addCase(actionVerifyQR.fulfilled, (state, action) => {
        state.verifyQR.loading = false;
        state.verifyQR.data = action.payload;
      })
      .addCase(actionVerifyQR.rejected, (state, action) => {
        state.verifyQR.loading = false;
        state.verifyQR.data = action.payload;
        state.verifyQR.error = action.error.message || "Something went wrong";
      });
  },
});

export default QRcodeSlice.reducer;
export const { actions, reducer } = QRcodeSlice;
